import { render, staticRenderFns } from "./AboutProject.vue?vue&type=template&id=4cb9dc97&"
import script from "./AboutProject.vue?vue&type=script&lang=js&"
export * from "./AboutProject.vue?vue&type=script&lang=js&"
import style0 from "./AboutProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports